<template>
    <div>
        <div>
            <el-form :inline="true" ref="searchForm" :model="searchForm" class="forTbFilter flowStatistics"
                label-position="left" @submit.native.prevent>
                <el-form-item label="账单月份：">
                    <el-date-picker v-model="searchForm.month" type="month" placeholder="选择核算月份"
                        value-format="yyyy-MM"></el-date-picker>
                </el-form-item>
                <el-form-item label="池组名称：">
                    <el-select v-model="searchForm.poolId" clearable filterable>
                        <el-option v-for="item in pkgGroup" :key="item.id" :value="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="btnArea">
                    <el-button type="primary" @click="getFlowStatisticsHandler" plain icon="el-icon-search">搜 索 查 询</el-button>
                </el-form-item>
            </el-form>

        </div>



        <el-table :data="everyDayTbpg.tableData" border height="600">
            <el-table-column type="index" label="序号" align="center"></el-table-column>
            <el-table-column prop="month" label="账单月份" align="center"></el-table-column>
            <el-table-column prop="poolName" label="池组名称" align="center"></el-table-column>
            <!-- <el-table-column prop="inventAmount" label="账户总充值（元）" align="center"></el-table-column> -->
            <el-table-column prop="monthTotalPrice" label="池组总消费（元）" align="center"></el-table-column>
            <el-table-column prop="subAmount" label="流量扣费（元）" align="center"></el-table-column>
            <el-table-column prop="shareData" label="共享总量（G）" align="center"></el-table-column>
            <el-table-column prop="subData" label="真实用量（G）" align="center"></el-table-column>
            <el-table-column prop="stopPrice" label="保号扣费（元）" align="center"></el-table-column>
            <el-table-column prop="stopNum" label="保号个数" align="center"></el-table-column>
            <el-table-column prop="activePrice" label="激活扣费（元）" align="center"></el-table-column>

            <el-table-column prop="createTime" label="时间" align="center"></el-table-column>
            <el-table-column label="操作" align="center" width="200">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="selectYu(scope.row)">查询详情</el-button>
                    <el-button type="text" size="small" @click="exportApplyHandler(scope.row)">数据导出</el-button>
                </template>
            </el-table-column>

        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="everyDayTbpg.currentPage" :page-sizes="[15, 50, 100, 500]" :page-size="everyDayTbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="everyDayTbpg.total">
        </el-pagination>


        <el-dialog :append-to-body="true" title="账单同步" :visible.sync="importCardVisible" width="600px" @close="cancel"
            :close-on-click-modal="false">
            <p style="color: red;">备注：选择扣减余额后，系统会自动计算每个卡流量使用差 进行扣费。</p>
            <el-form ref="importCardForm" :model="importCardForm" label-width="100px">
                <template>
                    <el-form-item label="导入Excel：" prop="uploadExcel">
                        <el-upload ref="upload" :action="uploadUrl('pool/excel/pool/data')" :headers="setHeader()"
                            :limit="1" :auto-upload="false" :data="importCardForm" :on-change="handleChange"
                            :on-success="handleSuccess">
                            <el-button slot="trigger" plain>导入Excel</el-button>
                            <el-button style="margin-left: 10px;" plain
                                @click="exportExcel('/mould/download?type=poolData')">导出模板</el-button>
                        </el-upload>
                    </el-form-item>
                </template>

                <el-form-item label="账单月份：">
                    <el-date-picker v-model="importCardForm.month" type="month" placeholder="选择核算月份"
                        value-format="yyyy-MM"></el-date-picker>
                </el-form-item>

                <el-form-item label="扣减余额：" prop="isSub">
                    <el-radio-group v-model="importCardForm.isSub">
                        <el-radio label="0">不扣减</el-radio>
                        <el-radio label="1">扣减池组余额</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="所属池组：" prop="poolId">
                    <el-select v-model="importCardForm.poolId" filterable>
                        <el-option v-for="item in pkgGroup" :key="item.id" :value="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureImportCardHandle">确 定</el-button>
            </div>
        </el-dialog>





        <el-dialog :append-to-body="true" title="流水记录" :visible.sync="actionLogVisible" width="1000px"
            :close-on-click-modal="false">
            <el-table :data="actionLogTbpg.tableData" border height="421">
                <el-table-column label="序号" type="index" width="50"></el-table-column>
                <el-table-column prop="amount" label="交易金额"></el-table-column>
                <el-table-column prop="balance" label="交易余额"></el-table-column>
                <el-table-column prop="typeName" label="交易类型" width="100"></el-table-column>
                <el-table-column prop="remark" label="交易备注"></el-table-column>
                <el-table-column prop="createName" label="系统备注"></el-table-column>
                <el-table-column prop="createTime" label="交易时间" width="140"></el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChanges" @current-change="handleCurrentChanges"
                :current-page="actionLogTbpg.currentPage" :page-sizes="[15, 50, 100, 500]"
                :page-size="actionLogTbpg.pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="actionLogTbpg.total">
            </el-pagination>
            <span slot="footer" class="dialog-footer">
                <el-button @click="actionLogVisible = false">关 闭</el-button>
            </span>
        </el-dialog>



    </div>
</template>
<script>
import { flowStatistics, flowEveryDayDetail, flowEveryMonthDetail, flowStatisticsExport } from '@/api/csm.js'
import common from '@/utils/common.js'
var echarts = require('echarts');      // 引入 ECharts 主模块
export default {
    data() {
        return {
            importCardVisible: false,
            importCardForm: {
                isSub: '0'
            },
            agentListOption: [],
            searchForm: {
                agentName: '',
                iccid: null,
                remark: '',
                time: null,
                into_no: null,
                supplierCode: '',
                basePkgGroup: '',
                dataAmount: null,
            },
            pkgGroup: [],
            //每月流量详情表
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },

            //每日流量详情表
            everyDayTbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            thisMonth: '',
            activeName: 'everyMonthTable',
            everyDayAmountData: [],
            branchSupplierOption: [],
            monthFlow: [{
                createTime: '',
                dataAmount: ''
            }],

            stopMessage: '0',
            moreThanNumber: '0',
            sumTotoalData: '0',
            totalOutData: '0',

            actionLogVisible: false,
            actionLogTbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            infoLog: {
                id: '',
                month: '',
            }


        }
    },
    methods: {
        exportApplyHandler(row) {
            var data = {
                id: row.poolId,
                month:row.month
            }
            this.$confirm('确定导出吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                common.sysRequest('export/poolLog', data, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.$message.success('数据导出中,请稍候去任务中心下载');
                    } else {
                        this.$message.error(res.data.msg);
                    }
                })
            }).catch(() => {

            });
        },


        selectYu(row, $event) {
            if (row && row.poolId) {
                this.infoLog.id = row.poolId;
                this.infoLog.month = row.month;
            }
            common.resetCurrentPage(this, $event, 'actionLogTbpg');
            let data = common.getRequestParams(this, 'actionLogTbpg', this.infoLog);
            common.sysRequest('pool/select/amount/info', data, 'post').then(res => {
                common.listCallback(this, res, 'actionLogTbpg');
                this.actionLogVisible = true;
            })
        },
        handleSizeChanges(val) {
            this.actionLogTbpg.pageSize = val;
            this.selectYu();
        },
        handleCurrentChanges(val) {
            this.actionLogTbpg.currentPage = val
            this.selectYu();
        },

        handleChange(file, fileList) {
            if (fileList.length > 0) {
                this.$refs.importCardForm.fields[0].clearValidate();
            }
        },


        cancel() {
            this.importCardForm = {};
            this.importCardVisible = false;
        },
        sureImportCardHandle() {
            this.$refs.importCardForm.validate(valid => {
                this.$refs.upload.submit();   //号段批量导入
            })
        },

        handleSuccess(res) {
            if (res.code == 200) {
                this.importCardVisible = false;
                this.$refs.upload.clearFiles();
                this.$message.success(res.message);
            } else {
                this.$message.error(res.message);
            }
        },


        getFlowStatisticsHandler($event) {
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            common.sysRequest('pool/select/pool/month', data, 'post').then(res => {
                common.listCallback(this, res, 'everyDayTbpg');
            })

        },

        formatDataAmount() {
            this.searchForm.dataAmount = this.searchForm.dataAmount.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');
        },

        //获取每日流量数据
        getFlowEveryDayHandler($event) {
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            if (data.dataAmount) {
                data.dataAmount = data.dataAmount * 1024;
            }
            data.iccid = this.currentIccic;
            flowEveryDayDetail(data).then(res => {
                common.listCallback(this, res, 'everyDayTbpg');
                this.activeName = 'everyDayTable';
            })
        },

        goToDetailPage(row) {
            this.$store.commit('menu/setFromPage', 'orderMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },

        exportInfoHandle() {//导出excel文件
            this.$confirm("请注意！！！ 请选择对应搜索条件后再进行导出，避免数据过大。 一次性导出不建议超过50W张！确定要导出吗？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                common.deleteSpaceKey(this.searchForm);
                let param = this.searchForm;
                if (param.dataAmount) {
                    param.dataAmount = param.dataAmount * 1024;
                }
                common.sysRequest('export/poolData', param, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.$message.success('数据导出中,请稍候去任务中心下载');
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(err => console.error(err));
            }).catch(() => { });
        },


        drawFlowStatisticsChart(elementId, everyDayAmountData) {
            let dataAxis = [];
            let data = [];
            let yMax = 500;
            let dataShadow = [];
            let myChart = echarts.init(document.getElementById(elementId));



            for (let i = 0; i < everyDayAmountData.length; i++) {
                dataAxis.push(everyDayAmountData[i].createTime);
                data.push(everyDayAmountData[i].dataAmount);
            }

            yMax = Math.max(...data);

            for (let i = 0; i < data.length; i++) {
                dataShadow.push(yMax);
            }


            let option = {
                title: {
                    text: '每日流量统计',
                },
                xAxis: {
                    data: dataAxis,
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        show: false
                    },
                    z: 10
                },
                yAxis: {
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#999'
                        }
                    }
                },
                dataZoom: [
                    {
                        type: 'inside'
                    }
                ],
                series: [
                    { // For shadow
                        type: 'bar',
                        itemStyle: {
                            normal: { color: 'rgba(0,0,0,0.05)' }
                        },
                        barGap: '-100%',
                        barCategoryGap: '40%',
                        data: dataShadow,
                        animation: false,
                    },
                    {
                        type: 'bar',
                        label: {
                            normal: {
                                show: true,
                                position: 'insideTop'
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        { offset: 0, color: '#83bff6' },
                                        { offset: 0.5, color: '#188df0' },
                                        { offset: 1, color: '#188df0' }
                                    ]
                                )
                            },
                            emphasis: {
                                color: new echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        { offset: 0, color: '#2378f7' },
                                        { offset: 0.7, color: '#2378f7' },
                                        { offset: 1, color: '#83bff6' }
                                    ]
                                )
                            }
                        },
                        data: data
                    }
                ]
            };

            myChart.setOption(option);
        },

        handleSizeChange(val) {
            this.tbpg.pageSize = val;
            this.getFlowStatisticsHandler();
        },
        handleCurrentChange(val) {
            this.tbpg.currentPage = val
            this.getFlowStatisticsHandler();
        },
    },
    created() {
        common.getAgentListOptionCom(this, 'agentListOption');
        common.sysRequest('pool/select/pool/user/list', {}, 'post').then(res => {
            this.pkgGroup = res.data.data;
        })
        this.thisMonth = this.dateFormat("yyyy-MM", new Date());
        common.getBranchSupplierOptionCom(this, 'branchSupplierOption');
    },

    mounted() {
        this.getFlowStatisticsHandler();
    },

    updated: function () {

    },

    watch: {

    }
}
</script>

<style>
.flowStatistics .el-input-group__prepend,
.flowStatistics .el-input-group__append {
    background-color: #f5f5f5;
}

.flowStatistics .el-form-item__content {
    width: 250px;
}
</style>

<style lang="less" scoped>
.forTbFilter {
    display: inline-block;

    .btnArea {
        display: inline-block;
        margin-left: 30px;

    }
}

.stopMessage {
    font-size: 18px;
    margin: 0 0 10px 0;

    span {
        color: #ea2929;
        margin-right: 60px;

    }
}
</style>